module.exports = __webpack_public_path__ + "img/mrBts_test_006_BS.da3c0720.jpg";